import Selectorg from './Selectorg'
import CategoryCas from './CategorySelect'
import CustomTransfer from './CustomTransfer'
import CityCascader from './CityCascader'
import FormTable from './FormTable'
import FormTableItem from './FormTable/form-table-item.vue'
export default {
    install(Vue)  {
        Vue.component(Selectorg.name, Selectorg)
        Vue.component(CategoryCas.name, CategoryCas)
        Vue.component(CustomTransfer.name, CustomTransfer)
        Vue.component(CityCascader.name, CityCascader)
        Vue.component(FormTable.name, FormTable)
        Vue.component(FormTableItem.name, FormTableItem)
    }
}



// WEBPACK FOOTER //
// ./src/components/index.js